<template>
  <div>
    <v-card flat class="px-2 mx-7 mb-4">
      <div v-html="seeAnnouncement.Content"></div>
    </v-card>
    <div class="d-flex justify-space-between pt-4 px-8">
      <div class="d-flex justify-start">
        <span class="index_h3"
          >Date at: {{ seeAnnouncement.PublishDate.split("T")[0] }}</span
        >
      </div>
    </div>
      <div class="d-flex justify-space-between pb-6 px-8">
      <div class="d-flex justify-start">
        <span class=" index_h3"
          >Visible to:  Standard , Practitioner , Instructor</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["infodialog", "seeAnnouncement"],
  data() {
    return {
      text: "Dear Instructors,You were notified last week of an IBA website technical issue that was interfering with the following emails going out:- Student registrations - confirmation to the student- Student registrations - notification to the Instructor- Purchase confirmations- Emails sent from Instructors to students through the IBA email students buttonOur IT team has resolved the issue and we have tested multiple scenarios and the issue appears to be resolved.For the time being, we still recommend that if you have any courses scheduled that you periodically sign into your IBA account and check your seminar registrations manually. Please notify us right away at office@bodytalksystem.com if you continue to experience any problems.Thank you,The IBA Team",
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.text_style_edit {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: -0.25px;
  color: #222222;
}
</style>
